<template>
  <div>
    <div :class="detailHide">
      <vs-table
        search
        stripe
        border
        description
        :sst="true"
        :data="table.data"
        :max-items="table.length"
        :total="table.total"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-3
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
               <span class="mr-2"
                >{{ this.table.start }} - {{ this.table.end }} of
                {{ this.table.total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in table.limits"
                :key="item"
                @click="handleChangelength(item)"
              >
                <span>{{ item }}</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div class="btn-group ml-10">
            <vs-button
              color="success"
              type="filled"
              @click="handleViewData()"
              >View Data</vs-button
            >
          </div>
          <div class="btn-group ml-1">
            <vs-button
              color="success"
              type="border"
              @click="handleExport()"
              >Export</vs-button
            >
          </div>
        </template>
        <template slot="thead">
          <vs-th style="text-align: center;"
            v-for="(head, index) in this.table.heads"
            :key="index"
            :sort-key="head.field"
            >{{ head.title }}</vs-th
          >
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              v-for="(head, index) in table.heads" :key="index" :data="data[indextr][head.field]">
              <span v-if="head.field === 'date'">{{
                dateFormat(data[indextr][head.field])
              }}</span>
              <span v-else-if="isCountField(head.field)">{{
                formatNumber(data[indextr][head.field])
              }}</span>
              <span v-else>{{ data[indextr][head.field] }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        style="padding-top: 5px"
        :total="table.totalPage"
        v-model="setPage"
      />
    </div>

  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    baseUrl: {
      type: String,
    },
    dateFrom: {
      type: String,
    },
    dateTo: {
      type: String,
    },
    reportName: {
      type: [String, Array],
    },
    status: {
      type: [String, Array],
    },
    // draw: {
    //   type: Number,
    // },
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      hasViewedData: false,
    };
  },
  methods: {
    handleViewData() {
      this.hasViewedData = true;
      this.table.page = 1;
      this.viewData();
    },
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "asc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [5, 10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
        heads: [
          { field: "date", title: "Stream Date" },
          { field: "name", title: "Report Name" },
          { field: "start_time", title: "Start Time Stream Data" },
          { field: "end_time", title: "End Time Stream Data" },
          { field: "duration", title: "Duration" },
          { field: "count_data_source", title: "Count Data Zesthub" },
          { field: "count_data_dest", title: "Count Data SDN" },
          { field: "status", title: "Status" },
          { field: "remark", title: "Error Message" },
        ],
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      if (!this.hasViewedData) {
        return;
      }
      this.viewData();
    },
    handleChangePage(page) {
      this.table.page = page;
      if (!this.hasViewedData) {
        return;
      }
      this.viewData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      if (!this.hasViewedData) {
        return;
      }
      this.viewData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      if (!this.hasViewedData) {
        return;
      }
      this.viewData();
    },
    viewData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            date_from: this.dateFrom,
            date_to: this.dateTo,
            report_name: this.reportName,
            status: this.status,
          },
        })
        .then((resp) => {
          this.tableDefaultState();
          if (resp.status === "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records || [];
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            this.table.total = 0;
            this.table.totalPage = 0;
            this.table.totalSearch = 0;
            this.table.length = 0;
            this.table.data = [];
            this.setStartEnd();
            this.$vs.loading.close();
          }
          this.$forceUpdate()
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    dateFormat(date) {
      if (!date) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString("id-ID");
    },
    isCountField(field) {
      return ["count_data_source", "count_data_dest"].includes(field);
    },
    handleExport() {
      this.$vs.loading();
      var filetitle =
        "STREAM_DATA_MONITORING_" + this.dateFrom + "_" + this.dateTo;
      this.$http
        .get(this.baseUrl + "/export", {
          params: {
            title: filetitle,
            date_from: this.dateFrom,
            date_to: this.dateTo,
            report_name: this.reportName,
            status: this.status,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.status == "error") {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Processing",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        });
    },
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    setPage: {
      get() {
        return this.table.page;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
